const View = () => import('./View')

export default function install(Vue) {
  Vue.component('checkout-view', View)
}
